<script>
import Loader from "./loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";

export default {
  mixins: [Api, Sabit],
   emits: ["yenidata"], 
  data() {
    return { 
      TableData: [],
      YeniData:[],
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      Uygulamaid:null,
    }
  },
  components: {
    Loader,
  },
  props: {
    updating: {
      type: Boolean,
    },
  },
  methods:{

    Get() {  


    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };

     let Filter = "&Kisaadi=STR";

    this.ActionsFilterGet({Service: "Ouygulama",  Page:Page,Filter:Filter}).then((res) => {
        if(res){
          this.Uygulamaid=res.Data[0].Id;

           Filter = "&UygulamaId="+this.Uygulamaid;


                this.ActionsFilterGet({"Service":"ODuyuru", "Page":this.Page, Filter:Filter}).then((res) => { 
                  this.TableData = res.Data; 

                  this.YeniData = this.TableData.filter(x => x.YeniMi === true);
                  if (this.YeniData.length > 0) {
                      this.$emit("yenidata", this.YeniData);
                  }


                });

        }
    });


    }
  }
};
</script>
<template>
  <Loader :loading="isLoading">
    <div class="card">
      <div class="card-body">

        <h4 class="card-title mb-5">{{this.$t('StrWidgets.ODuyuru.Title')}}</h4>
        <ul class="verti-timeline list-unstyled">
          <li class="event-list" v-for="Data in TableData" :key="Data.Id">
            <div class="event-timeline-dot">
              <i class="bx bx-right-arrow-circle font-size-18"></i>
            </div>
            <div class="media">
              <div class="me-3">
                <h5 class="font-size-14">
                  {{ Data.IslemTarihi | formatDateTable }}
                  <i
                    class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
                  ></i>
                </h5>
              </div>
              <div class="media-body">
                <h5>{{ Data.Baslik }}</h5>
                <div> {{ Data.Icerik }}</div>
              </div>
            </div>
          </li> 
        </ul> 
      </div>
    </div>
  </Loader>
</template>